module.exports = __webpack_public_path__ + "static/media/imgmision.14704fbf.png";